<ng-container *transloco="let t">
  @if (
    (isBillingOwner() || onboardingStatus() === OnboardingStatus.ProductTour) &&
    onboardingStatus() &&
    onboardingStatus() !== OnboardingStatus.Done
  ) {
    @if (onlyButton()) {
      <div>
        <button iButton size="sm" (click)="executeAction()">
          {{ buttonLabel() }}
          <IIcon name="chevronRight" />
        </button>
      </div>
    } @else {
      <div
        class="flex flex-col gap-2.5 border-t px-[18px] py-2.5"
        [class]="hasLessThan7DaysLeft() ? 'bg-destructive-background' : 'bg-main-gradient-subtle'"
      >
        @switch (onboardingStatus()) {
          @case (OnboardingStatus.StartedFreeTest) {
            <div class="flex items-center justify-between gap-2">
              <span class="type-body-medium text-foreground">{{ t("onboarding.free_test") }}</span>
              <span class="type-caption text-muted-foreground">
                {{ t("onboarding.days_left", { count: remainingDaysForFreeTest() }) }}
              </span>
            </div>
          }
          @case (OnboardingStatus.FreeTestExpired) {
            <span class="type-body-medium text-foreground">{{ t("onboarding.free_test_expired") }}</span>
          }
          @case (OnboardingStatus.StarterPlan) {
            <span class="type-body-medium text-foreground">{{ t("onboarding-cta.upgrade_to_pro_plan") }}</span>
          }
          @case (OnboardingStatus.ProductTour) {
            <span class="type-body-medium text-foreground">{{ t("product-tour.upgrade_title") }}</span>
          }
          @case (OnboardingStatus.OnboardingCallScheduled) {
            @if (onboardingDate()) {
              <span class="type-caption text-muted-foreground text-center">{{
                t("onboarding-cta.call_planned", { date: onboardingDate() | date: "short" : undefined : locale() })
              }}</span>
            }
          }
        }
        <button
          iButton
          class="w-full whitespace-normal"
          size="md"
          [variant]="hasLessThan7DaysLeft() ? 'destructive' : 'main'"
          (click)="executeAction()"
        >
          {{ buttonLabel() }}
        </button>
        @if (onboardingStatus() === OnboardingStatus.ProductTour) {
          <a iButton class="w-full" size="md" variant="secondary" [href]="autopilotUrl">
            {{ t("default-layout.back_to_autopilot") }}
          </a>
        }
      </div>
    }
  }
</ng-container>
